import axios from 'axios';

export default {
    async fetchCars() {
        return axios.get('/cars');
    },

    async fetchCarById(id) {
        return axios.get(`/cars/${id}`);
    },

    async addCar(car) {
        return axios.post('/cars',
            car,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async updateCarInfo(carInfo) {
        return axios.put('/cars/car-info',
            carInfo,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async addOrEditNote(note) {
        return axios.post('/cars/edit-note',
            note,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async deleteNote(noteId) {
        return axios.delete('/cars/delete-note/' + noteId,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async addOrEditVignette(vignette) {
        return axios.post('/cars/edit-vignette',
            vignette,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async deleteVignette(vignetteId) {
        return axios.delete('/cars/delete-vignette/' + vignetteId,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },
}
